import { validate as validateUuid } from 'uuid'

import type { ControllerListIdentifier } from '@/features/controller/types'

const ID_SEPARATOR_REGEX = /[^\w-]+/

export interface ControllerListIdentifiersParseResult {
  validIdentifiers: ControllerListIdentifier[]
  invalidIdentifiers: string[]
}

export function parseControllerListIdentifiers(input: string): ControllerListIdentifiersParseResult {
  const items = input
    .trim()
    .split(ID_SEPARATOR_REGEX)
    .filter((item) => item.length > 0)

  const validIdentifiers: Set<ControllerListIdentifier> = new Set()
  const invalidIdentifiers: Set<string> = new Set()

  for (const item of items) {
    if (validateUuid(item)) {
      validIdentifiers.add({ rawValue: item, id: item })
    } else {
      const number = Number.parseInt(item, 10)
      if (number === undefined || Number.isNaN(number) || number.toString().length !== item.length) {
        invalidIdentifiers.add(item)
      } else {
        validIdentifiers.add({ rawValue: item, equipmentNumber: number })
      }
    }
  }

  return {
    validIdentifiers: validIdentifiers.values().toArray(),
    invalidIdentifiers: invalidIdentifiers.values().toArray(),
  }
}
